// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  if ( newUrl == url ) {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}



// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#AccessibleNav'),
    
        // Sidebar
    $sidebar: $('#AccessibleSidebar'),

    // Collection Pages
    $changeView: $('.change-view'),
    $switchbox: $('#switchbox'),
    $switch: $('#rcheck'),
    $colbod: $('#colbod'),
    $scrlTop: $('#scrlBtn'),

    // Product Page
    $productImageWrap: $('#ProductPhoto'),
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail')
  }
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.accessibleSidebar();
  timber.productImageSwitch();
  timber.autoResponsiveElements();
  timber.collectionViews();
  timber.productImageZoom();
  timber.oosSwitch();
  timber.scrollBtn();
};

timber.scrollBtn = function () {
  //Get the button
var $mybutton = timber.cache.$scrlTop;
  
    $mybutton.on('click', function(evt) {
 window.scrollTo(0, 0);
  });


               };
               

timber.oosSwitch = function () {
  var $ooss = timber.cache.$switch,
      $swbox = timber.cache.$switchbox,
      $collectionBod = timber.cache.$colbod,
      $cards = $collectionBod.find('.oos'),
      showClass = 'navoff';
  
    $swbox.on('fastclick', function(evt) {
     if($ooss.checked == false) {
        $ooss.checked = true; 
    }
    else {
        if($ooss.checked == true) {
            $ooss.checked = false; 
         }   
    }
  });
  
    $ooss.each(function() {
    var mycookie = $.cookie($(this).attr('name'));
    if (mycookie && mycookie == "true")  {
        $cards.addClass(showClass),
        $(this).prop('checked', mycookie);
        }
   
});
   
    // change
    $ooss.on('change', function(evt) {
      
          $.cookie($(this).attr("name"), $(this).prop('checked'), {
        path: '/',
        expires: 365
    })    
          
      var $el = $(this),
          $collectionBod = timber.cache.$colbod,
          $cards = $collectionBod.find('.oos'),
          mycookie = $.cookie($(this).attr('name'));
      

    
      if (mycookie && mycookie == "true") {
        $cards.addClass(showClass)
    } else {
        $cards.removeClass(showClass)
    }
});
  

};  

timber.accessibleSidebar = function () {
  var $sdb = timber.cache.$sidebar,
      $sideparents = $sdb.find('.r-sidebar-header'),
      activeClass = 'nav-hover',
      subClass = 'rsb-open',
      focusClass = 'nav-focus';
  
    // Mouseclick
    $sideparents.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(subClass)) {
      evt.preventDefault();
         }
      
      if( evt.currentTarget == evt.target ) {
      
      
        
    $el.toggleClass(subClass);
        
      }
      
  });
  
};  
  
  
  

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $grandparents = $nav.find('.site-nav__t2'),
      $grandobj = $nav.find('.site-nav--has-granddropdown'),
      $grandchildren = $nav.find('sitenav__granddroplink'),
      $toggleNav = $nav.find('.site-nav__show'),
      $toggleExtra = $nav.find('.navtoggle'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      $grandMenuLinks = $nav.find('.site-nav--has-granddropdown').find('a'),
      activeClass = 'nav-hover',
      subClass = 'sub-hover',
      focusClass = 'nav-focus',
      roundClass = 'noround',
      hideclass = 'navoff';
 

  // Mouseenter
 $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
  if (!$el.hasClass(activeClass)) {
     evt.preventDefault();
   }
 showDropdown($el);
 });

  $parents.on('mouseleave', function(evt) {
    var $el = $(this).find( "ul" );
    
     evt.preventDefault();
  $el.removeClass(roundClass);
 }); 
  
  
      $grandparents.on('mouseenter', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(subClass)) {
      evt.preventDefault();
         }
    $el.addClass(subClass).siblings().removeClass(subClass);
  });
  
       $grandparents.on('mouseenter', function(evt) {
    var $el = $(this).parent();

    if (!$el.hasClass(roundClass)) {
      evt.preventDefault();
         }
    $el.removeClass(roundClass);
  });

  
   $grandobj.on('mouseenter', function(evt) {
    var $el = $(this).parent();

    if (!$el.hasClass(roundClass)) {
      evt.preventDefault();
         }
    $el.addClass(roundClass);
  });
  

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });
  
    $grandMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $toggleNav.on('click', function(evt) {

    
   //  $(this).children('.navtoggle').toggleClass(hideclass);
    
  var $el =  $nav.find('.navtoggle');

   //  $el.toggleClass(hideclass);
   $('.nav-hover').find('.navtoggle').toggleClass(hideclass);
    $('.nav-hover').find('.morenav-icon').toggleClass('flip');
    
  });
  
  

  
  
  
  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        isGrandItem = $('.site-nav--has-granddropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else     
      if (!isGrandItem) {
      removeFocus($topLevel);
      removeFocus(isSubItem);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }
  
    function subDropdown ($el) {
    $el.addClass(subClass).siblings().removeClass(subClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hidesubDropdown($el);
      });
    }, 250);
  }


  function hideDropdown ($el) {
    var subremove = $('.sub-hover');
    $el.removeClass(activeClass);
    subremove.removeClass(subClass);
    timber.cache.$body.off('touchstart');
  }
  
    function hidesubDropdown ($el) {
    $el.removeClass(subClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);

  
    // Update new image src to grande
    var zoomSrc = src.replace('_medium','_1024x1024').replace('_large','_1024x1024');
    $el.attr('data-zoom', zoomSrc);

    $(function() {
      timber.productImageZoom();
    });
  
};

timber.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.productImageZoom = function () {
  

  if (!timber.cache.$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
    return;
  };

  // Destroy zoom (in case it was already set), then set it up again
  timber.cache.$productImageWrap.trigger('zoom.destroy');

  timber.cache.$productImageWrap.addClass('image-zoom').zoom({
    url: timber.cache.$productImage.attr('data-zoom')
  });
};





// Initialize Timber's JS on docready
$(timber.init)


